import { create } from 'zustand'

import type { SofaPlatformCore } from './core-api'

type CoreStore = {
  core: null | SofaPlatformCore
  setCore: (core: SofaPlatformCore) => void
}
type UseCoreStore = ReturnType<typeof createStore>

function createStore() {
  return create<CoreStore>((set) => ({
    core: null,
    setCore: (core) => {
      set({ core })
    },
  }))
}

// HACK: To keep the store alive during HMR in development
export let useCoreStore: UseCoreStore

if (import.meta.hot) {
  if (!import.meta.hot.data.__ZUSTAND_STORE__) {
    import.meta.hot.data.__ZUSTAND_STORE__ = createStore()
  }
  useCoreStore = import.meta.hot.data.__ZUSTAND_STORE__
} else {
  useCoreStore = createStore()
}
